import styled from 'styled-components';

export const TravelContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ArrowsContainer = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  padding: 0 8px 0 8px;
  padding-bottom: 10px;

  & > svg {
    margin-bottom: -8px !important;
  }
`;

export const TravelInfo = styled.span`
  font-size: 16px;
  font-weight: 600;
  color: ${({ theme }) => theme.autosHeader.titleColor};
  font-stretch: normal;
  font-style: normal;
  line-height: 24px;
  letter-spacing: normal;
  text-align: center;
  white-space: nowrap;
  max-width: 220px;
  text-overflow: ellipsis;
  overflow: hidden;
`;

export const DateInfo = styled.span`
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 20px;
  letter-spacing: normal;
  text-align: center;
  color: ${({ theme }) => theme.autosHeader.infoColor};
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const DaysInfo = styled.span`
  display: inline;
  font-size: 12px;
  color: ${({ theme }) => theme.autosHeader.titleColor};
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 7px;
`;

export const Clock = styled.img`
  width: 14px;
  height: 14px;
  margin-right: 2px;
`;
